export default __webpack_public_path__ + "static/03_revision_workbooks-33c6179e21dd9fb3d62ef108821df5ca.png";